function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.9087 4.20132C16.9206 4.36872 16.9206 4.53616 16.9206 4.70357C16.9206 9.80963 13.0343 15.693 5.93119 15.693C3.74286 15.693 1.71001 15.0592 0 13.9591C0.31092 13.995 0.609841 14.0069 0.932724 14.0069C2.73836 14.0069 4.40055 13.3971 5.7279 12.3567C4.02986 12.3208 2.60684 11.2087 2.11656 9.67811C2.35574 9.71396 2.59488 9.73789 2.84602 9.73789C3.1928 9.73789 3.5396 9.69003 3.86245 9.60637C2.09267 9.2476 0.765283 7.69307 0.765283 5.81566V5.76785C1.27946 6.05484 1.87741 6.23421 2.51114 6.2581C1.47079 5.56452 0.789209 4.38069 0.789209 3.04138C0.789209 2.32391 0.980502 1.66621 1.31535 1.09222C3.21668 3.436 6.07467 4.9666 9.27939 5.13404C9.21962 4.84705 9.18373 4.54813 9.18373 4.24917C9.18373 2.12061 10.9057 0.386719 13.0462 0.386719C14.1583 0.386719 15.1627 0.853081 15.8683 1.60644C16.7412 1.43903 17.5782 1.11615 18.3197 0.673714C18.0326 1.57059 17.4228 2.32394 16.6216 2.80223C17.3989 2.71857 18.1523 2.50327 18.8458 2.20435C18.3198 2.96964 17.662 3.65122 16.9087 4.20132Z",
  fill: "white"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/twitter.abf6a52b.svg";
export { SvgComponent as ReactComponent };